import publicBuill from '../../../../components/reimbursement/js/publicBuill'
import JjxmFybxd from '../../../../components/reimbursement/jjxmFybxd'
import oaFybxd from '../../../../components/reimbursement/oaFybxd'
import JJFKSQD from '../../../../components/reimbursement/jjFksqd'
import jksqd from '../../../../components/reimbursement/jksqd'
import fksqd from '../../../../components/reimbursement/fksqd'
import saleBill from '../../../../components/reimbursement/saleBill'
import saleFybxd from '../../../../components/reimbursement/saleFybxd'
export default {
  components: {
    JjxmFybxd,
    jksqd,
    oaFybxd,
    fksqd,
    JJFKSQD,
    saleBill,
    saleFybxd
  },
  data() {
    return {
      billTemplate: {
        rowData: {},
        company: '',
        view: 'view',
        jjxmFybxdShow: false,
        oaFybxdShow: false,
        jksqdShow: false,
        fksqdShow: false,
        jjFksqdShow: false,
        saleBillShow: false,
        saleFybxdShow: false
      },
      queryData: {
        roles: '', // 查看那些单据数据
        rejected: '', // 退回标志
        state: '' // 是否归档 1：未归档 2：已归档
      },
      billCode: '',
      jkr: '',
      billType: [],
      pageConfig: {
        currentPage: 1,
        pageSizes: [20, 50, 100, 200],
        pageSize: 50,
        total: 0,
        status: '1',
        jeArr: [0.00, 0.00, 0.00]
      },
      tableData: [],
      sumArr: []
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs['billTable'].doLayout()
    })
  },
  created() {
    publicBuill.setThis(this)
    this.billType = publicBuill.getBillTree('')
    this.queryData.roles = publicBuill.getTreeValue(this.billType)
    const obj = {}
    obj.label = '全部'
    obj.value = this.queryData.roles
    this.billType.unshift(obj)
    this.queryBillData() // 第一次打开页面 查看 全部单据 的全部数据
  },
  methods: {
    /* 每页多少条 */
    handleSizeChange(size) {
      this.pageConfig.pageSize = size
      this.queryBillData()
    },
    // 调制 第几页
    handleCurrentChange(currentpage) {
      this.pageConfig.currentPage = currentpage
      this.queryBillData()
    },
    queryBillData() {
      if (!this.queryData.roles) {
        this.$message.error('该用户缺少数据查看权限！！')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '查询中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        borrower: localStorage.getItem('userName'), // 当前用户
        roles: this.queryData.roles, // 查看那些单据数据
        billCode: this.billCode, // 单据号
        jkr: this.jkr !== '' ? this.jkr : null, // 借款人
        currentPage: this.pageConfig.currentPage, // 第几页 开始
        limit: this.pageConfig.pageSize // 每页多少条
      }
      this.$post('/fesback/voided/queryVoidedTotal.z', data).then(res => {
        if (res.data) {
          const sqje = res.data.sqje.toFixed(2)
          const tgje = res.data.tgje.toFixed(2)
          const paymentJe = publicBuill.formatAmount(sqje)
          const approvedJe = publicBuill.formatAmount(tgje)
          this.sumArr = ['', '合计', '', '', '', paymentJe, approvedJe]
        }
      })
      this.$post('/fesback/voided/queryVoidedBill.z', data).then(res => {
        publicBuill.tableDataFormatter(res.data.data)
        this.tableData = res.data.data
        this.pageConfig.total = res.data.count
        loading.close()
      }).catch(res => {
        loading.close()
      })
    },
    async viewData(row) {
      const loading = this.$loading({
        lock: true,
        text: '查询中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const djh = row.billCode.substring(0, 2)
      this.billTemplate.rowData = await publicBuill.findVoidBillDataByBillCode(row.billCode, row.lrr)
      if (djh === 'FY') {
        this.billTemplate.oaFybxdShow = true
      } else if (djh === 'JJ' || djh === 'ZJ') {
        this.billTemplate.jjxmFybxdShow = true
      } else if (djh === 'JK') {
        this.billTemplate.jksqdShow = true
      } else if (djh === 'FK') {
        this.billTemplate.fksqdShow = true
      } else if (djh === 'JM' || djh === 'JN' || djh === 'ZM' || djh === 'ZN') {
        this.billTemplate.jjFksqdShow = true
      } else if (djh === 'CB') {
        this.billTemplate.saleBillShow = true
      } else if (djh === 'FB') {
        this.billTemplate.saleFybxdShow = true
      }
      loading.close()
    },
    getSummaries(param) {
      return this.sumArr
    }

  }
}
